// Gerado por scripts/build-icons.mjs — não editar manualmente.
import { createBankIcon } from "../createBankIcon";

/** Square */
export const Square = createBankIcon({
  name: "Square",
  slug: "square",
  compe: null,
  color: "#ffffff",
  viewBox: "0 0 100.03096 100.03096",
  html: "<rect\n     style=\"fill:#ffffff;fill-opacity:1\"\n     id=\"square_rect1\"\n     width=\"100.03096\"\n     height=\"100.03096\"\n     x=\"0\"\n     y=\"0\" />\n  <g transform=\"translate(21.0155,21.0155) scale(2.41667)\">\n    <path d=\"M4.01 0A4.01 4.01 0 0 0 0 4.01v15.98c0 2.21 1.8 4 4.01 4.01h15.98C22.2 24 24 22.2 24 19.99V4A4.01 4.01 0 0 0 19.99 0H4zm1.62 4.36h12.74c.7 0 1.26.57 1.26 1.27v12.74c0 .7-.56 1.27-1.26 1.27H5.63c-.7 0-1.26-.57-1.26-1.27V5.63a1.27 1.27 0 0 1 1.26-1.27zm3.83 4.35a.73.73 0 0 0 -.73.73v5.09c0 .4.32.72.72.72h5.1a.73.73 0 0 0 .73-.72V9.44a.73.73 0 0 0 -.73-.73h-5.1Z\" style=\"fill:#3E4348\" fill-rule=\"evenodd\" />\n  </g>",
});
